import { useTranslation } from "react-i18next";

/**
 * Translated reservation status pill.
 * Uses subtle neutral colors — never loud badges.
 */
export default function StatusPill({ status, size = "sm" }) {
    const { t } = useTranslation();
    const map = {
        confirmed:    "bg-blue-50 text-blue-700 ring-blue-100",
        checked_in:   "bg-emerald-50 text-emerald-700 ring-emerald-100",
        checked_out:  "bg-slate-100 text-muted-foreground ring-slate-200",
        pending:      "bg-amber-50 text-amber-700 ring-amber-100",
        on_hold:      "bg-amber-50 text-amber-700 ring-amber-100",
        hold:         "bg-amber-50 text-amber-700 ring-amber-100",
        cancelled:    "bg-rose-50 text-rose-700 ring-rose-100",
        no_show:      "bg-rose-50 text-rose-700 ring-rose-100",
        option:       "bg-violet-50 text-violet-700 ring-violet-100",
    };
    const cls = map[status] || map.pending;
    const label = t(`dashboard.res_status_${status || "pending"}`, { defaultValue: status || "—" });
    const sizeCls = size === "xs"
        ? "px-1.5 py-[1px] text-[10px]"
        : "px-2 py-0.5 text-[10.5px]";
    return (
        <span className={`inline-flex items-center rounded font-medium ring-1 ${cls} ${sizeCls}`}
              data-testid={`status-pill-${status}`}>
            {label}
        </span>
    );
}
